'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _nowAsEpoch = require('../date/nowAsEpoch');

var _nowAsEpoch2 = _interopRequireDefault(_nowAsEpoch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (loginTime, interval) {
    return interval - ((0, _nowAsEpoch2.default)() - loginTime) % interval;
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/date/timeLeftToNextRealityCheck.js
// module id = 72
// module chunks = 0